import { useCallback, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

const errMsg = (e, fallback) => apiError(e, fallback);

// Workspace member list + admin actions (add, role change, remove, reset link).
export function useMembers(workspaceId) {
  const [members, setMembers] = useState([]);
  const [reset, setReset] = useState(null); // {url, expires_at, email}
  const [invited, setInvited] = useState(null);
  const base = `/workspaces/${workspaceId}/members`;

  const load = useCallback(() => api.get(`/workspaces/${workspaceId}/members`).then((r) => setMembers(r.data)), [workspaceId]);
  useEffect(() => { if (workspaceId) load(); }, [workspaceId, load]);

  const add = async (form) => {
    try {
      const { data } = await api.post(base, { ...form, origin: window.location.origin });
      toast.success(data.invite_sent ? `Invite email sent to ${form.email}` : "Member added");
      if (data.temp_password) setInvited({ email: form.email, temp_password: data.temp_password });
      load();
      return true;
    } catch (e) { toast.error(errMsg(e, "Could not add member")); return false; }
  };
  const changeRole = async (mid, role) => {
    const fd = new FormData();
    fd.append("role", role);
    await api.patch(`${base}/${mid}`, fd);
    toast.success("Role updated"); load();
  };
  const remove = async (mid) => {
    if (!window.confirm("Remove this member?")) return;
    await api.delete(`${base}/${mid}`);
    toast.success("Removed"); load();
  };
  const resetLink = async (m) => {
    try { const { data } = await api.post(`${base}/${m.id}/reset-link`, { origin: window.location.origin }); setReset(data); }
    catch (e) { toast.error(errMsg(e, "Could not create reset link")); }
  };
  const copyReset = async () => { await navigator.clipboard.writeText(reset.url); toast.success("Link copied"); };

  return { members, add, changeRole, remove, resetLink, reset, clearReset: () => setReset(null), copyReset, invited, clearInvited: () => setInvited(null) };
}
